import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { StationsState } from '../../types';

import { addFavouriteStations as addFavouriteStationsOperation } from '../operations/addFavouriteStations';

import { STATUS_LOADING } from 'common/constants';

export const addFavouriteStations = (builder: ActionReducerMapBuilder<StationsState>) => builder
  .addCase(addFavouriteStationsOperation.pending, (state) => {
    state.favouriteStations.addingStatus = STATUS_LOADING.load;
  })
  .addCase(addFavouriteStationsOperation.fulfilled, (state, { payload: { favouriteStations } }) => {
    state.favouriteStations.addingStatus = STATUS_LOADING.done;
    state.favouriteStations.data = [...(state.favouriteStations.data || []), ...favouriteStations];
  })
  .addCase(addFavouriteStationsOperation.rejected, (state) => {
    state.favouriteStations.addingStatus = STATUS_LOADING.error;
  });
